import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/download/sec8_phone1.png'
import _imports_1 from '@/assets/img/download/sec8_phone2.png'


const _hoisted_1 = { class: "max-w-4xl mx-auto flex flex-col-reverse sm:flex-row w-[896px]:px-0 px-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "sm:mt-0 mt-20 sm:-translate-x-12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "lg:mt-40 mt-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium lg:my-20 my-0 leading-relaxed text-lg sm:text-xl sm:leading-relaxed text-center sm:text-left text-[#3E4044]" }, [
    /*#__PURE__*/_createTextVNode("파충류 관련 유익한 정보와"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 사육&케어 및 다양한 소식지 콘텐츠를 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 제공해요.")
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "lg:mt-40 mt-16"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBox = _resolveComponent("TitleBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["sm:w-1/2 w-full transition-all duration-1000 delay-300", _ctx.elClass])
    }, _hoisted_4, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["sm:w-1/2 w-full flex flex-col relative transition-all duration-1000 opacity-0", _ctx.elClass]),
      ref: "elRef"
    }, [
      _createVNode(_component_TitleBox, {
        title: "정보",
        content1: "흩어진 정보는 여기에서,",
        content2: "가장 빠른 파충류 소식지",
        align: "items-end"
      }),
      _hoisted_5
    ], 2)
  ]))
}